import ja from './ja';

const en: typeof ja = {
  common: {
    appName: 'Monju Chiebukuro',
    ok: 'OK',
    cancel: 'Cancel',
    confirmTitle: 'Confirm',
    signIn: 'Sign In',
    signOut: 'Sign Out',
    profile: 'Profile',
    mainMenu: 'MAIN MENU',
    userAdminMenu: 'ADMIN MENU',
    sysAdminMenu: 'SYSTEM ADMIN MENU',
    msg: {
      signOutConfirm: 'Are you sure you are signing out?',
    },
  },
  entities: {},
  pages: {
    top: {
      title: 'Top',
    },
    sampleList: {
      title: 'Sample List',
      listHeader: '○○○ List',
      createButton: "Create New",
    },
  },
};

export default en;
